// OBT F3-D — Kurumsal hafıza rozetleri (renk + metin birlikte; a11y).
import { cn } from '@/lib/utils';
import {
  ASSET_TYPE_LABELS,
  ASSET_EVENT_LABELS,
  WARRANTY_STATUS_LABELS,
  WARRANTY_STATUS_TONES,
  memoryLabel,
} from './memoryEnums';

const TONE = Object.freeze({
  neutral: 'bg-gray-100 text-gray-700 ring-gray-300',
  info: 'bg-blue-50 text-blue-700 ring-blue-300',
  success: 'bg-green-50 text-green-700 ring-green-300',
  danger: 'bg-red-50 text-red-700 ring-red-300',
});

export function WarrantyBadge({ status }) {
  const tone = WARRANTY_STATUS_TONES[status] || 'neutral';
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ring-inset',
        TONE[tone]
      )}
    >
      {`Garanti: ${memoryLabel(WARRANTY_STATUS_LABELS, status)}`}
    </span>
  );
}

export function AssetTypeBadge({ type }) {
  return (
    <span className="inline-flex items-center rounded-full bg-slate-100 px-2.5 py-0.5 text-xs font-semibold text-slate-700 ring-1 ring-inset ring-slate-200">
      {memoryLabel(ASSET_TYPE_LABELS, type)}
    </span>
  );
}

export function EventTypeBadge({ type }) {
  return (
    <span className="inline-flex items-center rounded-full bg-indigo-50 px-2 py-0.5 text-xs font-medium text-indigo-700 ring-1 ring-inset ring-indigo-200">
      {memoryLabel(ASSET_EVENT_LABELS, type)}
    </span>
  );
}
